// OrderForm.js
import React, { useState, useRef, useEffect, useContext } from 'react';
import BagsList from './BagsList';
import Notiflix from "notiflix";
import { FaShoppingCart } from 'react-icons/fa';
import Payment from './Payment'; // Import Payment component
import { endpoint } from './endpoint';
import { useNavigate, Link } from "react-router-dom";
import { UserContext } from './UserContext'; // Import UserContext

const generateGUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

const OrderForm = () => {
    const { user } = useContext(UserContext); // Use UserContext
    const [selectedBags, setSelectedBags] = useState([]);
    const [triggerPayment, setTriggerPayment] = useState(false);
    const [collectionID] = useState(generateGUID());
    const checkboxesRef = useRef({});
    const [bagsStatus, setBagsStatus] = useState([]);
    const navigate = useNavigate();

    const handleBagSelection = (bagId) => {
        setSelectedBags(prevState =>
            prevState.includes(bagId)
                ? prevState.filter(id => id !== bagId)
                : [...prevState, bagId]
        );
        setTriggerPayment(false);
    };

    const handleButtonClick = (bagId) => {
        if (checkboxesRef.current[bagId]) {
            checkboxesRef.current[bagId].click();
        }
    };

    const handleProceedToPayment = () => {
        if (selectedBags.length > 0) {
            setTriggerPayment(false);
            setTimeout(() => setTriggerPayment(true), 0);
        } else {
            Notiflix.Report.warning("Missing Bags", 'Please select at least one bag to proceed with payment.', "Ok");
        }
    };

    useEffect(() => {
        if (!user) {
            //navigate('/login'); // Redirect to login if user is not available
            return;
        }

        fetch(`${endpoint}/gymapp/getbags.php?token=${user.token}`)
            .then(res => res.json())
            .then(data => {
                setBagsStatus(data.bags);
            })
            .catch(err => {
                console.error('Error fetching bags:', err);
            });
    }, [user, navigate]);

    const bagPrice = 30;
    const selectedBagsCount = selectedBags.length;
    const totalAmount = selectedBagsCount * bagPrice * 100; // Total in cents for YOCO

    return (
        <div className="container" style={{ paddingBottom: "100px",paddingTop:"5px" }}>
            <br /><br /><br />
            <h3 className="text-left">Select bags to add to order</h3>
            <hr style={{ marginBottom: "15px" }}/>
            <div className="row">
                <div className="col">
                    {bagsStatus.length > 0 ? (
                        <ul>
                            <BagsList
                                bagsStatus={bagsStatus}
                                selectedBags={selectedBags}
                                handleBagSelection={handleBagSelection}
                                handleButtonClick={handleButtonClick}
                            />
                        </ul>
                    ) : (
                        <p>No bags available. <Link to="/scan">Scan bags you have purchased here</Link></p>
                    )}
                </div>
            </div>

            <hr />
            <div className="container">
                <div className="row justify-content-center">
                    {/* Payment Information Card */}
                    <div className="card payment-card mb-3 col-lg-8 shadow-sm">
                        <div className="card-body">
                            <h4 className="card-title">Payment Information</h4>

                            {/* Cart Details Integrated */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <p className="mb-1">
                                        <strong>Selected Bags:</strong> <span className="ml-2">{selectedBagsCount}</span>
                                    </p>
                                    <p>
                                        <strong>Total to Pay:</strong> <span className="ml-2">R{(totalAmount / 100).toFixed(2)}</span>
                                    </p>
                                </div>
                                <FaShoppingCart
                                    className="text-light"
                                    style={{ fontSize: "3rem", padding: "10px" }}
                                />
                            </div>

                            {/* Payment Icons */}
                            <div className="payment-icons mb-3 d-flex justify-content-around">
                                <i className="fab fa-cc-visa fa-2x"></i>
                                <i className="fab fa-cc-mastercard fa-2x"></i>
                                <i className="fab fa-cc-amex fa-2x"></i>
                                <i className="fab fa-cc-discover fa-2x"></i>
                            </div>

                            {/* Proceed to Payment Button */}
                            <center>
                                <button
                                    className="btn btn-dark btn-block"
                                    onClick={handleProceedToPayment}
                                    disabled={selectedBags.length === 0}
                                >
                                    Proceed to Payment
                                </button>
                            </center>
                        </div>
                    </div>
                </div>
            </div>

            {triggerPayment && (
                <Payment
                    bags={selectedBags}
                    total={totalAmount}
                    collectionID={collectionID}
                    user={user.email}
                />
            )}
            <br /><br /><br />
        </div>
    );
};

export default OrderForm;
